<template>
  <div
    class="template-wrap so-month-event-template"
    v-bind:style="{
      'background-color':
        data.WOType === 'Maintenance' ? 'gray' : data.TransportStatusHexColour,
    }"
  >
    <div class="subject">
      <span>{{ data.subject }}</span>
      <span>{{ data.WorkOrderFriendlyStatus }}</span>
    </div>
    <div class="description">
      <span>SO # {{ data.SalesOrderCode }}</span>
      <span>{{ data.ProductCode }}</span>
    </div>
    <GcCommentIcon v-if="data.HasNote === 'Y'" class="calendar-comment" />
  </div>
</template>

<script>
import { formatNumber } from "devextreme/localization";
import GcCommentIcon from "../gc-comment-icon.vue";
export default {
  components: { GcCommentIcon },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    getFormattedQty(value) {
      return formatNumber(value, "##,###,###,###,##0.00");
    },
  },
};
</script>

<style lang="scss">
.e-appointment,
.e-appointment-details {
  .so-month-event-template {
    padding: 5px 5px;
    width: 100%;
    .subject,
    .description {
      display: flex;
      justify-content: space-between;
      font-size: 12px;
      align-items: center;
    }

    .subject,
    .description {
      span:last-child {
        font-size: 10px;
      }
    }

    .description {
      font-size: 12px;
    }
  }
}
</style>
